import { DetailsCard } from "../../../../-components/details-card"
import { StatusBadge } from "../../../../-components/status-badge"
import { ActivityTypeText } from "../activity-type-text"
import { ProductionTitleText } from "../../../../-components/production-title"
import dayjs from "dayjs"
import { ActivityDto } from "../../../../../../@client/Theasoft_ApiServer_Activities"
import { FieldData } from "../../../../../../-components/field-data"
import { useTranslation } from "react-i18next"
import { getFormattedTimePeriod } from "../../../../../../utils/get-formatted-time"
import { ColumnLayout } from "../../../../-components/column-layout"
import {
  LabeledValue,
  LabeledValueProps,
} from "../../../../../../-components/default-list/labeled-value"
import { DefaultListItem } from "../../../../../../-components/default-list/list-item"

import { Divider } from "@mantine/core"

interface Props {
  activity: ActivityDto
}

export function StartTab({ activity }: Props) {
  const { t } = useTranslation("app_server")
  const activityDetails: LabeledValueProps[] = [
    {
      label: t("Title"),
      value: <ProductionTitleText productionTitle={activity.title} />,
    },
    { label: t("Stage"), value: activity.location },
    {
      label: t("ActivityType"),
      value: (
        <ActivityTypeText
          name={activity.activityType.name}
          rehearseNumber={activity.rehearseNumber}
          foreColor={activity.activityType.foreColor}
          backColor={activity.activityType.backColor}
        />
      ),
    },
    {
      label: t("Date"),
      value: dayjs(activity.date).format("dd L"),
    },
    {
      label: t("TimePeriod"),
      value: getFormattedTimePeriod(activity.timePeriod),
    },
    { label: t("ArtisticNote"), value: activity.artisticNote },
    { label: t("TechnicalNote"), value: activity.technicalNote },
    ...activity.activityFields.map((v) => ({
      label: v.type.name,
      value: <FieldData fieldData={v} />,
    })),
  ]
  return (
    <ColumnLayout>
      <DetailsCard
        title={t("Details")}
        buttons={
          <StatusBadge key={"details-status-badge"} status={activity.status} />
        }
      >
        {activityDetails.map((item, index, array) => (
          <React.Fragment key={item.label + "-" + index}>
            <DefaultListItem>
              <LabeledValue label={item.label} value={item.value} />
            </DefaultListItem>
            {index < array.length && <Divider />}
          </React.Fragment>
        ))}
      </DetailsCard>
    </ColumnLayout>
  )
}
